module.exports = __webpack_public_path__ + "static/media/R-180HD_CrossSection.302478eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/chambers/es/R-180HD_CrossSection.png
// module id = 484
// module chunks = 0